/* helper.ts */

/* Interfaces */
import { FeatureTypesResponse } from "src/shared/interfaces/api/FeatureTypes";

import {
  EntityType,
  BasicProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

import { DateRestrictionType } from "src/shared/interfaces/custom-cohorts/DateRestriction";

export const transformFeatureTypes = (
  data: FeatureTypesResponse
): BasicProps[] => {
  return Object.keys(data).map((key) => {
    const { type } = data[key];
    return mapEntityToProps(type!, key, data);
  });
};

const mapEntityToProps = (
  type: EntityType,
  key: string,
  data: FeatureTypesResponse
): BasicProps => {
  switch (type) {
    case EntityType.UNSUPPORTED:
      return {
        entity: {
          name: key,
          type: type,
          options: [],
        },
        unit: data[key].unit,
        dateRestriction: DateRestrictionType.FIRST,
      };
    case EntityType.BOOLEAN:
      return {
        entity: {
          name: key,
          type: type,
          options: [true, false],
        },
        unit: data[key].unit,
        dateRestriction: DateRestrictionType.FIRST,
        value: true,
      };
    case EntityType.NUMERIC:
      return {
        entity: {
          name: key,
          type: type,
          range: data[key].range!,
        },
        unit: data[key].unit,
        dateRestriction: DateRestrictionType.FIRST,
        boundaries: {
          lowerBound: data[key].range?.min!,
          upperBound: data[key].range?.max!,
        },
      };
    case EntityType.CONCEPT:
      return {
        entity: {
          name: key,
          type: type,
          options: data[key].options!,
        },
        unit: data[key].unit,
        dateRestriction: DateRestrictionType.FIRST,
        values: [data[key].options![0]],
      };
    default: {
      return {
        entity: {
          name: key,
          type: type,
          options: [],
        },
        dateRestriction: DateRestrictionType.FIRST,
      };
    }
  }
};
